import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './AboutPage.css';
import Team from '../components/Team';

const sectionVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0 }
};

const sectionTransition = (delay = 0) => ({
  duration: 0.5,
  ease: 'easeOut',
  delay
});

const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <main className="about-page">
        <motion.section
          className="about-hero"
          variants={sectionVariants}
          initial="hidden"
          animate="visible"
          transition={sectionTransition(0)}
        >
          <div className="about-hero-inner">
            <div className="about-hero-text">
              <p className="about-hero-label">ABOUT US</p>
              <h1 className="about-hero-title">We scale businesses with digital transformation</h1>
              <p className="about-hero-description">
                Lorem ipsum dolor sit amet consectetur. Elit etiam in nunc quisque. Tristique sed vitae magna aliquam at et mauris neque.
                Consectetur tincidunt tortor ultricies gravida eu eget. Eget sed maecenas purus sed netus rhoncus ac. Aliquet amet pellentesque
                tortor mus suspendisse at orci sed sit.
              </p>
              <button className="about-hero-cta">Hire Us</button>
            </div>
            <div className="about-hero-image-wrapper">
              <img src="/about_team.jpg" alt="Team collaborating" className="about-hero-image" />
            </div>
          </div>
        </motion.section>
        
        <motion.section
          className="about-vision"
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          transition={sectionTransition(0.05)}
        >
          <div className="about-vision-inner">
            <p className="about-vision-label">IFSTATIC TECHNOLOGIES</p>
            <h2 className="about-vision-title">Your Vision, Our Mission</h2>
            <p className="about-vision-description">
              Welcome to IfStatic Technologies, where we bring your aspirations to life. At the heart of our ethos is a commitment to turning your vision into reality. 
              Our mission is to collaborate with you, understand your goals, and provide innovative solutions that not only meet but exceed your expectations.
            </p>
          </div>
        </motion.section>

        <motion.section
          className="about-stats"
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          transition={sectionTransition(0.1)}
        >
          <div className="about-stats-inner">
            <div className="stat-item">
              <h3 className="stat-number">150+</h3>
              <p className="stat-label">Projects Completed</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">100+</h3>
              <p className="stat-label">Happy Clients</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">50+</h3>
              <p className="stat-label">Team Members</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">5+</h3>
              <p className="stat-label">Years of Experience</p>
            </div>
          </div>
        </motion.section>

        <motion.div
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          transition={sectionTransition(0.15)}
        >
          <Team />
        </motion.div>

        <motion.section
          className="cta-section"
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          transition={sectionTransition(0.2)}
        >
          <div className="cta-container">
            <p className="cta-label">Have questions or need more information?</p>
            <h2 className="cta-title">Reach out to us using the interactive form below or contact us directly.</h2>
            <button className="cta-button" onClick={() => navigate('/contact')}>Contact Us</button>
          </div>
        </motion.section>
      </main>
    </>
  );
};

export default AboutPage;
